import Style from 'ol/style/Style.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import CircleStyle from 'ol/style/Circle.js';
import Text from 'ol/style/Text.js';
export { colorAlpha } from './LoaderUtils.js';
import { colorAlpha } from './LoaderUtils.js'; // Also import for internal use in this file

// -------------------------------------------------------------------
// General Fallback Styles
// -------------------------------------------------------------------

export const defaultStyle = new Style({
    fill: new Fill({ color: 'rgba(220, 53, 69, 0.2)' }),
    stroke: new Stroke({ color: '#dc3545', width: 2 }),
    image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: '#dc3545' }),
        stroke: new Stroke({ color: '#fff', width: 2 })
    })
});

// Shared hidden style for memory efficiency (Zero-Allocation)
export const HIDDEN_STYLE = new Style({});


// -------------------------------------------------------------------
// KML Default Styles
// -------------------------------------------------------------------

export const defaultPointStyle = new Style({
    image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: '#dc3545' }),
        stroke: new Stroke({ color: '#ffffff', width: 2 }),
    }),
});

export const defaultLineStyle = new Style({
    stroke: new Stroke({ color: '#dc3545', width: 2 }),
});

export const defaultPolygonStyle = new Style({
    fill: new Fill({ color: 'rgba(220, 53, 69, 0.25)' }),
    stroke: new Stroke({ color: '#dc3545', width: 2 }),
});

export function styleByGeom(f) {
    const g = f.getGeometry();
    const type = g && g.getType ? g.getType() : '';
    if (type.includes('Point')) return defaultPointStyle;
    if (type.includes('LineString')) return defaultLineStyle;
    if (type.includes('Polygon')) return defaultPolygonStyle;
    return defaultPolygonStyle;
}


// -------------------------------------------------------------------
// AutoCAD (DXF/DWG) Cached Styles Generator
// -------------------------------------------------------------------

const cadStyleCache = new Map();

export function getCADStyles(entityColor) {
    if (cadStyleCache.has(entityColor)) return cadStyleCache.get(entityColor);
    
    const styles = {
        polyStyle: new Style({
            stroke: new Stroke({ color: entityColor, width: 1.5 }),
        }),
        polySimpleStyle: new Style({
            stroke: new Stroke({ color: entityColor, width: 0.5 }), // Thin stroke for far zoom
        }),
        lineStyle: new Style({
            stroke: new Stroke({ color: entityColor, width: 1.5 }),
        }),
        lineSimpleStyle: new Style({
            stroke: new Stroke({ color: entityColor, width: 0.5 }), // Thin stroke for far zoom
        }),
        pointStyle: new Style({
            image: new CircleStyle({ radius: 3, fill: new Fill({ color: entityColor }) })
        }),
        pointSimpleStyle: new Style({
            image: new CircleStyle({
                radius: 4,
                fill: new Fill({ color: entityColor }),
                stroke: new Stroke({ color: '#ffffff', width: 1 }),
            })
        })
    };
    
    cadStyleCache.set(entityColor, styles);
    return styles;
}

const textStyleCache = new Map();

export function getCADTextStyle(text, color) {
    const displayText = text.length > 20 ? text.substring(0, 17) + '…' : text;
    const key = displayText + '|' + color;

    if (textStyleCache.has(key)) return textStyleCache.get(key);

    const style = new Style({
        text: new Text({
            text: displayText,
            font: 'bold 11px Arial, sans-serif',
            fill: new Fill({ color: color }),
            stroke: new Stroke({ color: '#ffffff', width: 2 }),
            textAlign: 'center',
            textBaseline: 'middle',
            overflow: false,
            padding: [1, 2, 1, 2]
        })
    });

    if (textStyleCache.size > 15000) textStyleCache.clear();
    textStyleCache.set(key, style);
    return style;
}
